import React, { Component } from 'react';
import PropTypes from 'prop-types';

export const AgendaContext = React.createContext();

export default class AgendaContextProvider extends Component {

    static propTypes = {
        agendaUrl: PropTypes.string.isRequired,
        isWidget: PropTypes.bool,
        event: PropTypes.object,
        serverRendered: PropTypes.bool
    };


    state = {
        agendaUrl: this.props.agendaUrl,
        isWidget: this.props.isWidget,
        event: this.props.event,
        serverRendered: this.props.serverRendered
    };

    render() {
        return (
            <AgendaContext.Provider value={this.state}>
                {this.props.children}
            </AgendaContext.Provider>
        );
    }
}

export const AgendaContextConsumer = AgendaContext.Consumer;
